<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="所属大区：">
            <el-select
              v-model="query.areaUserId"
              filterable
              remote
              clearable
              size="small"
              placeholder="请输入大区经理姓名/手机号搜索"
              :remote-method="searchAreaManager"
              :loading="areaManagerLoading"
            >
              <el-option v-for="item in areaManagerOptions" :key="item.id" :label="item.realName + '(' + item.userPho + ')'" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="区域：">
            <el-cascader
              v-model="addressValue"
              :options="addressOptions"
              :props="cascaderProps"
              placeholder="请选择省/市/区（支持多选）"
              clearable
              size="small"
              collapse-tags
              @change="handleAddressChange"
              style="width: 280px;"
            />
          </el-form-item>
          <el-form-item label="用户身份：">
            <el-select
              v-model="query.userPositions"
              placeholder="全部"
              clearable
              size="small"
              multiple
              collapse-tags
            >
              <el-option-group v-for="group in identityOptions" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.label" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
            <el-button @click="handleBack" size="mini">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 汇总统计 + 大区统计 -->
    <el-card class="box-card mt10">
      <div class="statistics-container mb10">
        <div class="statistics-info">
          <span class="stat-item">平均观看时长: {{ formatDuration(summaryData.avgWatchDuration) }}</span>
          <span class="stat-item">总观看人数: {{ summaryData.totalViewCount || 0 }}人</span>
          <span class="stat-item">最长观看时长: {{ formatDuration(summaryData.maxWatchDuration) }}</span>
          <span class="stat-item">最低观看时长: {{ formatDuration(summaryData.minWatchDuration) }}</span>
        </div>
        <div class="export-btn">
          <el-button type="primary" size="mini" @click="handleExportArea" plain>导出大区统计</el-button>
        </div>
      </div>
      <el-table :data="areaStatistics" border>
        <el-table-column label="大区" prop="areaCustomerName" align="center" />
        <el-table-column label="参会人数" prop="attendeeCount" align="center" />
        <el-table-column label="体验班人数" prop="experienceCount" align="center" />
        <el-table-column label="研修班人数" prop="trainingCount" align="center" />
      </el-table>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleExport" plain>导出</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="55" />
        <el-table-column label="用户名称" prop="name" align="center" />
        <el-table-column label="身份" prop="levelName" align="center" />
        <el-table-column label="手机号" prop="phone" align="center" min-width="130" />
        <el-table-column label="所属区域" prop="fullAddr" align="center" />
        <el-table-column label="是否是大客户" prop="isBig" align="center"/>
        <el-table-column label="所属大区" prop="areaCustomerName" align="center" />
        <el-table-column label="技术线" prop="jishuline" align="center" />
        <el-table-column label="进入直播间次数" prop="joinCount" align="center" sortable />
        <el-table-column label="最后进入直播间时间" prop="lastLiveTime" align="center" sortable />
        <el-table-column label="观看直播时长" prop="liveTimeSpan" align="center" min-width="180" />
        <el-table-column label="下单量" prop="orderCount" align="center">
          <template slot-scope="{row}">
            {{ (row.seckillOrderCount || 0) + (row.balanceOrderCount || 0) }}
          </template>
        </el-table-column>
        <el-table-column label="充值金额" prop="rechargeAmount" align="center" />
        <el-table-column label="充值次数" prop="rechargeCount" align="center" />
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      liveId: null, // 直播ID
      query: {
        pageNo: 1,
        pageSize: 10,
        addrAreaCode: undefined, // 区
        addrCityCode: undefined, // 市
        addrProvinceCode: undefined, // 省
        liveId: 0
      },
      selectItems: [],
      // 所属大区（大区经理远程搜索）
      areaManagerLoading: false,
      areaManagerOptions: [],
      // 区域级联选择器相关数据
      addressValue: [], // 级联选择器的值
      addressOptions: [], // 区域选项数据
      cascaderProps: {
        value: 'regionCode',
        label: 'regionName',
        children: 'child',
        multiple: true,
        checkStrictly: false,
        emitPath: true
      },
      // 用户身份选项（分组）
      identityOptions: [],
      // 汇总统计数据
      summaryData: {
        avgWatchDuration: null,
        totalViewCount: 0,
        maxWatchDuration: null,
        minWatchDuration: null
      },
      // 大区统计数据
      areaStatistics: []
    }
  },
  created() {
    // 从路由参数获取liveId
    if (this.$route.query.liveId) {
      this.liveId = parseInt(this.$route.query.liveId)
      this.query.liveId = this.liveId
    }
    this.doQueryList({ pageNo: 1 })
    this.loadAddressData()
    this.loadIdentityData()
  },
  methods: {
    /**
     * 加载区域数据
     */
    async loadAddressData() {
      try {
        const response = await liveManageApi.getAddressTreeList({})
        if (response.code === '0' && response.data) {
          // 限制级联选择器只到第三级（省-市-区）
          this.addressOptions = this.limitAddressLevel(response.data, 3)
        }
      } catch (error) {
        console.error('加载区域数据失败:', error)
      }
    },
    
    /**
     * 限制地址数据层级，只保留指定层级
     * @param {Array} data 地址数据
     * @param {Number} maxLevel 最大层级（从1开始）
     * @param {Number} currentLevel 当前层级（默认为1）
     */
    limitAddressLevel(data, maxLevel, currentLevel = 1) {
      if (!data || !Array.isArray(data)) {
        return []
      }
      
      return data.map(item => {
        const newItem = { ...item }
        // 如果当前层级已达到最大层级，移除children
        if (currentLevel >= maxLevel) {
          delete newItem.child
        } else if (newItem.child && Array.isArray(newItem.child)) {
          // 递归处理子级
          newItem.child = this.limitAddressLevel(newItem.child, maxLevel, currentLevel + 1)
        }
        return newItem
      })
    },
    
    /**
     * 区域级联选择器变化处理
     */
    handleAddressChange(value) {
      if (value && value.length > 0) {
        const provinceCodes = new Set()
        const cityCodes = new Set()
        const areaCodes = new Set()
        value.forEach(path => {
          if (path.length >= 1) provinceCodes.add(path[0])
          if (path.length >= 2) cityCodes.add(path[1])
          if (path.length >= 3) areaCodes.add(path[2])
        })
        this.query.addrProvinceCodes = Array.from(provinceCodes).join(',') || undefined
        this.query.addrCityCodes = Array.from(cityCodes).join(',') || undefined
        this.query.addrAreaCodes = Array.from(areaCodes).join(',') || undefined
      } else {
        this.query.addrProvinceCodes = undefined
        this.query.addrCityCodes = undefined
        this.query.addrAreaCodes = undefined
      }
    },
    
    handleExport() {
      // 直接跳转到导出页面，传递筛选参数

      this.$router.push({
        path: '/export/list',
        query: {
          addrProvinceCodes: this.query.addrProvinceCodes || '',
          addrCityCodes: this.query.addrCityCodes || '',
          addrAreaCodes: this.query.addrAreaCodes || '',
          areaUserId: this.query.areaUserId || '',
          userPositions: this.query.userPositions || '',
          liveId: this.liveId,
          code: 'downloadStatisticsByLive'
        }
      })
    },
    handleRecharge(row) {
      this.$refs.recharge.handleShow(row)
    },
    handleLiveGoods(row) {
      this.$refs.liveGoods.handleShow(row)
    },
    copyStreamUrl(url) {
      this.$copyText(url).then(() => {
        this.$message.success('复制成功')
      })
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        liveId: this.liveId || 0
      }
      this.addressValue = [] // 重置区域选择器
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 返回上一页
     */
    handleBack() {
      this.$router.go(-1)
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }

      // 确保liveId参数正确传递
      if (this.liveId) {
        this.query.liveId = this.liveId
      }

      // 处理用户身份多选值转换为逗号分隔字符串
      const params = { ...this.query }
      if (Array.isArray(params.userPositions)) {
        params.userPositions = params.userPositions.join(',') || undefined
      }
      if (!params.areaUserId) {
        params.areaUserId = undefined
      }

      this.listLoading = true
      return liveManageApi.fetchLiveStatisticsByLive(params)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
          this.fetchSummaryAndAreaStats()
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 获取汇总统计和大区统计数据
     */
    fetchSummaryAndAreaStats() {
      const params = { liveId: this.liveId }
      liveManageApi.fetchLiveStatisticsSummaryByLive(params).then(data => {
        if (data.code === '0' && data.data) {
          this.summaryData = data.data
        }
      }).catch(err => {
        console.error('获取汇总统计失败:', err)
      })
      liveManageApi.fetchLiveAreaStatisticsByLive(params).then(data => {
        if (data.code === '0' && data.data) {
          this.areaStatistics = data.data || []
        }
      }).catch(err => {
        console.error('获取大区统计失败:', err)
      })
    },
    /**
     * 导出大区统计数据
     */
    handleExportArea() {
      this.$router.push({
        path: '/export/list',
        query: {
          liveId: this.liveId,
          code: 'downloadStatisticsAreaByLive'
        }
      })
    },
    /**
     * 格式化时长（分钟 → X小时Y分）
     */
    formatDuration(minutes) {
      if (minutes == null || minutes === 0) return '-'
      const hrs = Math.floor(minutes / 60)
      const mins = minutes % 60
      if (hrs > 0) return hrs + '小时' + mins + '分'
      return mins + '分'
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中批量启用？' : '确认将选中批量禁用？'
      this.$common.confirm(txt).then(() => sysGoodsCategorizeApi.setIsEnableBatch({ ids: ids, isEnable: type ? true : false }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      sysGoodsCategorizeApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.liveAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.liveAdd.handleUpdate(row)
    },
    /**
     * 加载用户身份数据（分组）
     */
    loadIdentityData() {
      liveManageApi.getAllIdentity().then(({ data }) => {
        if (data && Array.isArray(data)) {
          const grouped = {}
          data.forEach(item => {
            const typeKey = item.type !== undefined ? item.type : 'other'
            if (!grouped[typeKey]) {
              var typeLabel = '其他'
              if (typeKey === 1 || typeKey === '1') typeLabel = '技术线'
              else if (typeKey === 2 || typeKey === '2') typeLabel = '业务线'
              else if (typeKey === 3 || typeKey === '3') typeLabel = '其他'
              grouped[typeKey] = { label: typeLabel, options: [] }
            }
            grouped[typeKey].options.push({
              value: item.id,
              label: item.name || ''
            })
          })
          var order = { '1': 0, '2': 1 }
          this.identityOptions = Object.entries(grouped)
            .sort(function(a, b) {
              return (order[a[0]] != null ? order[a[0]] : 2) - (order[b[0]] != null ? order[b[0]] : 2)
            })
            .map(function(entry) { return entry[1] })
        } else {
          this.identityOptions = []
        }
      }).catch(function(err) {
        console.error('获取身份列表失败:', err)
        this.identityOptions = []
      })
    },
    /**
     * 远程搜索大区经理
     */
    searchAreaManager(query) {
      if (query !== '') {
        this.areaManagerLoading = true
        liveManageApi.searchUser({ keyword: query }).then(function(res) {
          var data = res.data
          this.areaManagerOptions = (data || []).filter(function(user) {
            return user.position === '大区经理'
          })
        }.bind(this)).catch(function() {
          this.areaManagerOptions = []
        }.bind(this)).finally(function() {
          this.areaManagerLoading = false
        }.bind(this))
      } else {
        this.areaManagerOptions = []
      }
    }
  }
}
</script>
<style scoped>
.statistics-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}
.statistics-info {
  display: flex;
  gap: 20px;
}
.stat-item {
  font-size: 14px;
  color: #606266;
}
.export-btn {
  margin-left: auto;
}
</style>
